import React from 'react'

import styled, { css } from 'styled-components'

import { Icon } from '_components/icon'
import { palette } from '_styles/variables'

export interface HelpTextProps {
  text: string
  hasError?: boolean
  renderHelpText?: (hasError?: boolean) => React.ReactElement
}

const StyledText = styled.p<Pick<HelpTextProps, 'hasError'>>`
  display: flex;
  margin: 0;
  margin-top: 0.25rem;
  font-size: 0.625rem;
  flex-direction: row;
  font-weight: 600;
  line-height: 0.875rem;

  & svg {
    margin-right: 0.25rem;
  }

  & span {
    color: inherit;
  }

  ${({ hasError }) =>
    hasError &&
    css`
      color: ${palette.ui.error};
      & svg {
        color: ${palette.ui.error};
      }
    `}
`

export const HelpText: React.FC<HelpTextProps> = ({
  hasError,
  text,
  renderHelpText,
}) =>
  typeof renderHelpText === 'function' ? (
    renderHelpText(hasError)
  ) : (
    <StyledText hasError={hasError}>
      {hasError && <Icon size="1.2em" icon="alert-circle" />}
      <span>{text}</span>
    </StyledText>
  )
